'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Search = function (_React$PureComponent) {
  _inherits(Search, _React$PureComponent);

  function Search() {
    _classCallCheck(this, Search);

    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
  }

  _createClass(Search, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { width: this.props.size, height: this.props.size, viewBox: '0 0 32 32' },
        _react2.default.createElement('path', {
          d: 'M31.46 31.37c-.74.8-1.98.84-2.77.08l-6.17-5.8c-5.7 4.7-13.94 4.04-18.87-1.52-4.94-5.55-4.9-14.12.12-19.6 5-5.5 13.24-6.06 18.88-1.28 5.64 4.78 6.76 13.27 2.56 19.44l6.15 5.8c.77.75.8 2.04.06 2.86zM13.88 24.8c5.56 0 10.06-4.66 10.06-10.42S19.44 3.95 13.88 3.95C8.32 3.95 3.8 8.62 3.8 14.38S8.33 24.8 13.9 24.8z',
          fill: '#00B083',
          fillRule: 'evenodd'
        })
      );
    }
  }]);

  return Search;
}(_react2.default.PureComponent);

Search.defaultProps = {
  size: 22
};

Search.propTypes = {
  size: _propTypes2.default.number
};

exports.default = Search;